export default __webpack_public_path__ + "static/media/IconsChairside_Education.c33b6747.svg";